import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/8.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-e041253a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container content" }
const _hoisted_2 = { class: "hero-info" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "color-text" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "background-style" }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "image-preview",
    src: _imports_0,
    alt: "preview"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["AppChimp"], null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('HomeHero.chimp')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('HomeHero.title')) + " ", 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('HomeHero.title_span')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('HomeHero.subtitle')), 1),
      _createVNode(_component_router_link, { to: {name:"SelectTemplate"} }, {
        default: _withCtx(() => [
          _createVNode($setup["AppButton"], { class: "customize-button" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('HomeHero.button')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_6
  ]))
}